import { Type } from 'class-transformer';
import { IsArray, IsInt, Min, ValidateNested } from 'class-validator';
import { IngredientResponseDto } from './ingredient-response.dto';

/**
 * Response of `GET /admin/ingredients`: the global catalog only
 * (`tenantId = null`), already unique per `normalizedName` (partial unique
 * index) — no dedup and no per-origin facets needed, unlike the tenant-facing
 * `IngredientsPageResponseDto`.
 */
export class AdminIngredientsPageResponseDto {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IngredientResponseDto)
  items!: IngredientResponseDto[];

  @IsInt()
  @Min(0)
  total!: number;

  @IsInt()
  @Min(1)
  page!: number;

  @IsInt()
  @Min(1)
  pageSize!: number;
}
